module.exports = window.CrashdownData;